import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "./About.css";
import { API } from "../../config/api";

export default function About() {
  const [aboutImages, setAboutImages] = useState({});
  const [activeImages, setActiveImages] = useState({});
  const [slideDirection, setSlideDirection] = useState({});
  const [selectedSection, setSelectedSection] = useState(null);
  const [activeSectionSlider, setActiveSectionSlider] = useState(0);
  const conceptSections = [
    {
      title: "Special Offers on Embroidery Designs",
      label: "SPECIAL OFFERS",
      folder: "offers",

      directLink: "/offers",

      links: [],

      text: (
        <>
          <p>
            Explore special offers and exciting deals on embroidery designs from
            LifeTime Creation.
          </p>

          <p>
            Discover selected embroidery designs and offers available for
            designers, boutiques, embroidery professionals and fashion creators.
          </p>
        </>
      ),
    },
    {
      title: "Saree CPallu Embroidery Designs",
      label: "SAREE CPALLU EMBROIDERY",
      folder: "sareecpallu",

      links: [
        {
          name: "Multi Design",
          url: "/category?cid=12&subcid=30&icid=114&menu=MULTI%20DESIGN",
        },
        {
          name: "Cording Design",
          url: "/category?cid=14&subcid=158&icid=415&menu=CORDING%20DESIGN",
        },
        {
          name: "Sequence Design",
          url: "/category?cid=13&subcid=39&icid=124&menu=SEQUIN%20DESIGN",
        },
        {
          name: "Chain Design",
          url: "/category?cid=19&subcid=135&icid=343&menu=CHAIN%20DESIGN",
        },
        {
          name: "Beads Design",
          url: "/category?cid=38&subcid=174&icid=482&menu=BEADS%20DESIGN",
        },
      ],

      text: (
        <>
          <p>
            Discover elegant saree embroidery designs created for traditional,
            contemporary and designer sarees.
          </p>

          <p>
            Whether you are creating a festive saree, designer collection or
            traditional ethnic outfit, our saree embroidery concepts provide
            inspiration for beautiful embroidery work.
          </p>
        </>
      ),
    },
    {
      title: "Neck & Gala Embroidery Designs",
      label: "NECK & GALA DESIGNS",
      folder: "neck",

      links: [
        {
          name: "Multi Design",
          url: "/category?cid=12&subcid=29&icid=225&menu=MULTI%20DESIGN",
        },
        {
          name: "Cording Design",
          url: "/category?cid=14&subcid=46&icid=123&menu=CORDING%20DESIGN",
        },
        {
          name: "Sequence Design",
          url: "/category?cid=13&subcid=151&icid=384&menu=SEQUIN%20DESIGN",
        },
        {
          name: "Chain Design",
          url: "/category?cid=19&subcid=63&icid=158&menu=CHAIN%20DESIGN",
        },
        {
          name: "Beads Design",
          url: "/category?cid=38&subcid=176&icid=484&menu=BEADS%20DESIGN",
        },
      ],

      text: (
        <>
          <p>
            Neck and gala embroidery designs are an important part of Indian
            ethnic fashion.
          </p>

          <p>
            Discover floral, geometric, traditional and contemporary gala
            embroidery patterns.
          </p>
        </>
      ),
    },
    {
      title: "Kurti Embroidery Designs",
      label: "KURTI EMBROIDERY",
      folder: "kurti",

      links: [
        {
          name: "Multi Design",
          url: "/category?cid=12&subcid=129&icid=332&menu=MULTI%20DESIGN",
        },
      ],

      text: (
        <>
          <p>
            Our kurti embroidery designs are created for both modern everyday
            wear and fashionable ethnic collections.
          </p>

          <p>
            LifeTime Creation brings together simple, elegant and detailed kurti
            embroidery concepts suitable for different fabrics and styles.
          </p>
        </>
      ),
    },

    {
      title: "Suit Daman & Dupatta Embroidery Designs",
      label: "SUIT DAMAN & DUPATTA EMBROIDERY",
      folder: "sutdaman",

      links: [
        {
          name: "Multi Design",
          url: "/category?cid=12&subcid=31&icid=198&menu=MULTI%20DESIGN",
        },
        {
          name: "Cording Design",
          url: "/category?cid=14&subcid=111&icid=276&menu=CORDING%20DESIGN",
        },
        {
          name: "Sequence Design",
          url: "/category?cid=13&subcid=86&icid=194&menu=SEQUIN%20DESIGN",
        },

        {
          name: "Beads Design",
          url: "/category?cid=38&subcid=175&icid=483&menu=BEADS%20DESIGN",
        },
      ],

      text: (
        <>
          <p>
            Suit Daman and Dupatta embroidery designs are some of the most
            popular categories at LifeTime Creation. Our collection includes
            creative embroidery concepts for Punjabi suits, Anarkali suits,
            straight suits and modern ethnic wear.
          </p>

          <p>
            Explore beautiful neckline patterns, front motifs, sleeve
            embroidery, daman borders, dupatta designs and complete suit
            concepts.
          </p>
        </>
      ),
    },

    {
      title: "Lehenga Embroidery Designs",
      label: "LEHENGA EMBROIDERY",
      folder: "lehenga",

      links: [
        {
          name: "Multi Design",
          url: "/category?cid=12&subcid=167&icid=447&menu=MULTI%20DESIGN",
        },
        {
          name: "Cording Design",
          url: "/category?cid=14&subcid=49&icid=106&menu=CORDING%20DESIGN",
        },
        {
          name: "Sequence Design",
          url: "/category?cid=13&subcid=42&icid=100&menu=SEQUIN%20DESIGN",
        },

        {
          name: "Beads Design",
          url: "/category?cid=38&subcid=172&icid=476&menu=BEADS%20DESIGN",
        },
      ],

      text: (
        <>
          <p>
            Lehenga embroidery designs require beautiful placement, balanced
            patterns and detailed decorative work.
          </p>

          <p>
            Explore embroidery ideas for lehenga borders, panels, blouse
            designs, dupattas and coordinated embroidery patterns.
          </p>
        </>
      ),
    },

    {
      title: "Blouse Embroidery Designs",
      label: "BLOUSE EMBROIDERY",
      folder: "blouse",

      links: [
        {
          name: "Multi Design",
          url: "/category?cid=12&subcid=28&icid=176&menu=MULTI%20DESIGN",
        },
        {
          name: "Cording Design",
          url: "/category?cid=14&subcid=45&icid=107&menu=CORDING%20DESIGN",
        },
        {
          name: "Sequence Design",
          url: "/category?cid=13&subcid=154&icid=397&menu=SEQUIN%20DESIGN",
        },
        {
          name: "Chain Design",
          url: "/category?cid=19&subcid=126&icid=321&menu=CHAIN%20DESIGN",
        },
      ],

      text: (
        <>
          <p>
            A beautifully embroidered blouse can transform the complete look of
            a saree or ethnic outfit.
          </p>

          <p>
            Explore neckline embroidery, back designs, sleeve patterns, borders
            and motifs.
          </p>
        </>
      ),
    },

    {
      title: "Butta Embroidery Designs",
      label: "BUTTA EMBROIDERY",
      folder: "butta",

      links: [
        {
          name: "Multi Design",
          url: "/category?cid=12&subcid=32&icid=329&menu=MULTI%20DESIGN",
        },
        {
          name: "Cording Design",
          url: "/category?cid=14&subcid=48&icid=105&menu=CORDING%20DESIGN",
        },
        {
          name: "Sequence Design",
          url: "/category?cid=13&subcid=40&icid=99&menu=SEQUIN%20DESIGN",
        },
        {
          name: "Chain Design",
          url: "/category?cid=19&subcid=125&icid=320&menu=CHAIN%20DESIGN",
        },
      ],

      text: (
        <>
          <p>
            Butta embroidery designs are perfect for creating elegant patterns
            across sarees, suits, kurtis and lehengas.
          </p>

          <p>
            Our collection includes floral, traditional, geometric and
            contemporary butti embroidery concepts.
          </p>
        </>
      ),
    },
    {
      title: "Butti Embroidery Designs",
      label: "BUTTI EMBROIDERY",
      folder: "butti",

      links: [
        {
          name: "Multi Design",
          url: "/category?cid=12&subcid=56&icid=136&menu=MULTI%20DESIGN",
        },
        {
          name: "Cording Design",
          url: "/category?cid=14&subcid=108&icid=271&menu=CORDING%20DESIGN",
        },
        {
          name: "Sequence Design",
          url: "/category?cid=13&subcid=165&icid=440&menu=SEQUIN%20DESIGN",
        },
      ],

      text: (
        <>
          <p>
            Butti embroidery designs are perfect for creating elegant patterns
            across sarees, suits, kurtis and lehengas.
          </p>

          <p>
            Our collection includes floral, traditional, geometric and
            contemporary butti embroidery concepts.
          </p>
        </>
      ),
    },

    {
      title: "Embroidery Lace Designs",
      label: "EMBROIDERY LACE",
      folder: "lace",

      links: [
        {
          name: "Multi Design",
          url: "/category?cid=12&subcid=27&icid=354&menu=MULTI%20DESIGN",
        },
        {
          name: "Cording Design",
          url: "/category?cid=14&subcid=47&icid=380&menu=CORDING%20DESIGN",
        },
        {
          name: "Sequence Design",
          url: "/category?cid=13&subcid=36&icid=101&menu=SEQUIN%20DESIGN",
        },
      ],

      text: (
        <>
          <p>
            Embroidery lace designs can be used to enhance sleeves, dupattas,
            saree borders and garment edges.
          </p>

          <p>
            Explore different embroidery lace styles for traditional and
            contemporary garments.
          </p>
        </>
      ),
    },

    {
      title: "Garment & Sherwani Embroidery Designs",
      label: "GARMENT & SHERWANI EMBROIDERY",
      folder: "servani",

      links: [
        {
          name: "Multi Design",
          url: "/category?cid=12&subcid=26&icid=180&menu=MULTI%20DESIGN",
        },
        {
          name: "Cording Design",
          url: "/category?cid=14&subcid=51&icid=122&menu=CORDING%20DESIGN",
        },
        {
          name: "Sequence Design",
          url: "/category?cid=13&subcid=41&icid=129&menu=SEQUIN%20DESIGN",
        },
        {
          name: "Chain Design",
          url: "/category?cid=19&subcid=65&icid=159&menu=CHAIN%20DESIGN",
        },
      ],

      text: (
        <>
          <p>
            Garment and Sherwani embroidery designs are created for traditional,
            festive and designer ethnic wear.
          </p>

          <p>
            Explore decorative front patterns, neck designs, borders, cuffs,
            sleeves and complete garment embroidery concepts.
          </p>
        </>
      ),
    },

    {
      title: "Free & Premium Embroidery Designs",
      label: "FREE & PREMIUM EMBROIDERY",
      folder: "free-premium",

      links: [
        {
          name: "Free Designs",
          url: "/category?cid=30&subcid=148&icid=381&menu=FREE%20%20DOWNLOAD",
        },
        {
          name: "Premium Designs",
          url: "/category?cid=12&subcid=35&icid=200&menu=MULTI%20DESIGN",
        },
      ],

      text: (
        <>
          <p>
            LifeTime Creation offers both free and premium embroidery designs.
            Our free embroidery designs allow users to explore different
            concepts.
          </p>

          <p>
            Our premium collection provides additional embroidery designs for
            professional, boutique and commercial embroidery requirements.
          </p>
        </>
      ),
    },
  ];
  /* ---------------------------------------------
     LOAD ABOUT IMAGES
  --------------------------------------------- */
  useEffect(() => {
    const fetchAboutImages = async () => {
      try {
        const response = await fetch(`${API.BASE_URL}/AboutImages.php`);
        const data = await response.json();

        if (data.success) {
          setAboutImages(data.folders || {});

          // Set every folder to first image
          const initialIndexes = {};

          Object.keys(data.folders || {}).forEach((folder) => {
            initialIndexes[folder] = 0;
          });

          setActiveImages(initialIndexes);
        }
      } catch (error) {
        console.error("Error loading About images:", error);
      }
    };

    fetchAboutImages();
  }, []);

  /* ---------------------------------------------
   SEO
--------------------------------------------- */
  useEffect(() => {
    document.title =
      "About LifeTime Creation | Embroidery Designs, Machine Embroidery & Free Designs";

    const description =
      "LifeTime Creation offers premium paid and free embroidery designs for Suts, sarees, kurtis, lehengas, blouses, neck designs, gala designs, butti, lace and more. Explore high-quality machine embroidery designs and embroidery concepts.";

    let metaDescription = document.querySelector('meta[name="description"]');

    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.name = "description";
      document.head.appendChild(metaDescription);
    }

    metaDescription.setAttribute("content", description);

    const keywords =
      "aari design classes near me, aari embroidery class, best embroidery designs, best embroidery designs for kurtis, best embroidery digitizer, best embroidery saree, best home embroidery machine, kurti embroidery designs, lehenga embroidery designs, blouse embroidery designs, gala designs, neck designs, embroidery butti, embroidery lace, embroidery concepts, computerized embroidery designs, embroidery designs download, LifeTime Creation";

    let metaKeywords = document.querySelector('meta[name="keywords"]');

    if (!metaKeywords) {
      metaKeywords = document.createElement("meta");
      metaKeywords.name = "keywords";
      document.head.appendChild(metaKeywords);
    }

    metaKeywords.setAttribute("content", keywords);

    return () => {
      document.title = "LifeTime Creation";
    };
  }, []);

  /* ---------------------------------------------
     AUTO SLIDER
  --------------------------------------------- */
  //   useEffect(() => {
  //     if (!Object.keys(aboutImages).length) {
  //       return;
  //     }

  //     const interval = setInterval(() => {
  //       setActiveImages((prev) => {
  //         const next = { ...prev };

  //         conceptSections.forEach((section) => {
  //           const images = aboutImages[section.folder] || [];

  //           if (images.length > 1) {
  //             const currentIndex = next[section.folder] || 0;

  //             next[section.folder] = (currentIndex + 1) % images.length;
  //           }
  //         });

  //         return next;
  //       });

  //       // Auto slide goes from right to left
  //       setSlideDirection((prev) => {
  //         const next = { ...prev };

  //         conceptSections.forEach((section) => {
  //           next[section.folder] = "next";
  //         });

  //         return next;
  //       });
  //     }, 4000);

  //     return () => clearInterval(interval);
  //   }, [aboutImages]);

  /* ---------------------------------------------
     NEXT IMAGE
  --------------------------------------------- */
  const handleNext = (folder, totalImages) => {
    if (totalImages <= 1) return;

    setSlideDirection((prev) => ({
      ...prev,
      [folder]: "next",
    }));

    setActiveImages((prev) => ({
      ...prev,
      [folder]: ((prev[folder] || 0) + 1) % totalImages,
    }));
  };

  /* ---------------------------------------------
     PREVIOUS IMAGE
  --------------------------------------------- */
  const handlePrevious = (folder, totalImages) => {
    if (totalImages <= 1) return;

    setSlideDirection((prev) => ({
      ...prev,
      [folder]: "prev",
    }));

    setActiveImages((prev) => ({
      ...prev,
      [folder]: ((prev[folder] || 0) - 1 + totalImages) % totalImages,
    }));
  };
  /* ---------------------------------------------
   AUTO SLIDER - ONE SECTION AT A TIME
--------------------------------------------- */
  useEffect(() => {
    if (!Object.keys(aboutImages).length) {
      return;
    }

    const interval = setInterval(() => {
      setActiveSectionSlider((prevSection) => {
        let nextSection = (prevSection + 1) % conceptSections.length;

        /*
        Find next section which actually has
        more than one image.
      */
        let checked = 0;

        while (
          checked < conceptSections.length &&
          (aboutImages[conceptSections[nextSection].folder] || []).length <= 1
        ) {
          nextSection = (nextSection + 1) % conceptSections.length;
          checked++;
        }

        const section = conceptSections[nextSection];

        if (section) {
          const images = aboutImages[section.folder] || [];

          if (images.length > 1) {
            setSlideDirection((prev) => ({
              ...prev,
              [section.folder]: "next",
            }));

            setActiveImages((prev) => ({
              ...prev,
              [section.folder]:
                ((prev[section.folder] || 0) + 1) % images.length,
            }));
          }
        }

        return nextSection;
      });
    }, 4000);

    return () => clearInterval(interval);
  }, [aboutImages]);
  /* ---------------------------------------------
     SEO
  --------------------------------------------- */
  useEffect(() => {
    document.title =
      "About LifeTime Creation | Embroidery Designs, Machine Embroidery & Free Designs";

    const description =
      "LifeTime Creation offers premium paid and free embroidery designs for Suts, sarees, kurtis, lehengas, blouses, neck designs, gala designs, butti, lace and more. Explore high-quality machine embroidery designs and embroidery concepts.";

    let metaDescription = document.querySelector('meta[name="description"]');

    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.name = "description";
      document.head.appendChild(metaDescription);
    }

    metaDescription.setAttribute("content", description);

    const keywords =
      "aari design classes near me, aari embroidery class, best embroidery designs, best embroidery designs for kurtis, best embroidery digitizer, best embroidery saree, best home embroidery machine, kurti embroidery designs, lehenga embroidery designs, blouse embroidery designs, gala designs, neck designs, embroidery butti, embroidery lace, embroidery concepts, computerized embroidery designs, embroidery designs download, LifeTime Creation";

    let metaKeywords = document.querySelector('meta[name="keywords"]');

    if (!metaKeywords) {
      metaKeywords = document.createElement("meta");
      metaKeywords.name = "keywords";
      document.head.appendChild(metaKeywords);
    }

    metaKeywords.setAttribute("content", keywords);

    return () => {
      document.title = "LifeTime Creation";
    };
  }, []);
  /* ---------------------------------------------
   AUTO SLIDER - INTRO IMAGES
--------------------------------------------- */
  useEffect(() => {
    const images = aboutImages.intro || [];

    if (images.length <= 1) {
      return;
    }

    const interval = setInterval(() => {
      setSlideDirection((prev) => ({
        ...prev,
        intro: "next",
      }));

      setActiveImages((prev) => ({
        ...prev,
        intro: ((prev.intro || 0) + 1) % images.length,
      }));
    }, 4000);

    return () => clearInterval(interval);
  }, [aboutImages]);
  return (
    <>
      <Helmet>
        <title>
          About LifeTime Creation | Embroidery Designs & Machine Embroidery
        </title>

        <meta
          name="description"
          content="Learn about LifeTime Creation and explore premium and free machine embroidery designs for sarees, suits, kurtis, lehengas, blouses, necklines, gala designs, butta, butti and embroidery lace."
        />

        <meta name="robots" content="index, follow" />

        <link rel="canonical" href="https://lifetimecreation.in/about" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="About LifeTime Creation | Embroidery Designs & Machine Embroidery"
        />

        <meta
          property="og:description"
          content="Explore premium and free machine embroidery designs for sarees, suits, kurtis, lehengas, blouses and more."
        />

        <meta property="og:type" content="website" />

        <meta property="og:url" content="https://lifetimecreation.in/about" />

        <meta
          property="og:image"
          content="https://lifetimecreation.in/backend/about/intro/about.png"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />

        <meta
          name="twitter:title"
          content="About LifeTime Creation | Embroidery Designs"
        />

        <meta
          name="twitter:description"
          content="Discover machine embroidery designs and embroidery concepts from LifeTime Creation."
        />
      </Helmet>
      <div className="about-page">
        {/* INTRODUCTION */}
        <section className="about-intro">
          <div className="about-container">
            <div className="about-intro-grid">
              <div className="about-intro-content">
                <div className="about-intro-heading">
                  <span className="section-label">WHO WE ARE</span>

                  <h2>About LifeTime Creation</h2>
                </div>

                <p>
                  <strong>LifeTime Creation</strong> is a creative platform
                  dedicated to providing high-quality embroidery designs for
                  designers, embroidery professionals, boutiques, manufacturers
                  and embroidery enthusiasts.
                </p>

                <p>
                  We offer a wide collection of both{" "}
                  <strong>paid and free embroidery designs</strong> created for
                  modern and traditional fashion requirements. Our collection
                  includes designs for{" "}
                  <strong>
                    Suts, sarees, kurtis, lehengas, blouses, necklines, gala
                    designs, butta, butti and lace
                  </strong>
                  .
                </p>

                <p>
                  Our goal is to make it easier for embroidery professionals and
                  fashion designers to discover beautiful, practical and
                  production-ready <strong>machine embroidery designs</strong>{" "}
                  in one place.
                </p>
              </div>

              <div className="about-intro-image">
                {aboutImages.intro && aboutImages.intro.length > 0 ? (
                  <>
                    <div
                      key={`intro-${activeImages.intro || 0}`}
                      className={`intro-slide intro-slide-${
                        slideDirection.intro || "next"
                      }`}
                    >
                      <img
                        src={aboutImages.intro[activeImages.intro || 0]}
                        alt="LifeTime Creation embroidery designs"
                      />
                    </div>

                    {/* LEFT ARROW */}
                    {aboutImages.intro.length > 1 && (
                      <>
                        <button
                          type="button"
                          className="intro-arrow intro-arrow-left"
                          onClick={() =>
                            handlePrevious("intro", aboutImages.intro.length)
                          }
                          aria-label="Previous intro image"
                        >
                          <i className="bi bi-chevron-left"></i>
                        </button>

                        {/* RIGHT ARROW */}
                        <button
                          type="button"
                          className="intro-arrow intro-arrow-right"
                          onClick={() =>
                            handleNext("intro", aboutImages.intro.length)
                          }
                          aria-label="Next intro image"
                        >
                          <i className="bi bi-chevron-right"></i>
                        </button>

                        {/* IMAGE COUNTER */}
                        <div className="intro-image-counter">
                          {(activeImages.intro || 0) + 1} /{" "}
                          {aboutImages.intro.length}
                        </div>
                      </>
                    )}
                  </>
                ) : (
                  <div className="concept-image-placeholder">
                    <i className="bi bi-image"></i>
                    <span>Loading images...</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>

        {/* COLLECTION INTRO */}
        <section className="collection-intro">
          <div className="about-container">
            <div className="collection-heading">
              <span className="section-label">OUR COLLECTION</span>

              <h2>Explore Our Embroidery Design Concepts</h2>

              <p>
                Discover embroidery patterns and concepts created for different
                garments, styles and fashion requirements.
              </p>
            </div>
          </div>
        </section>

        {/* CONCEPT SECTIONS */}
        <section className="concept-sections">
          <div className="about-container">
            {conceptSections.map((item, index) => {
              const images = aboutImages[item.folder] || [];

              const currentIndex = activeImages[item.folder] || 0;

              const image = images[currentIndex];

              const direction = slideDirection[item.folder] || "next";

              return (
                <article
                  className={`concept-row ${
                    index % 2 !== 0 ? "concept-row-reverse" : ""
                  }`}
                  key={item.title}
                >
                  {/* IMAGE */}
                  <div className="concept-image-wrapper">
                    <div className="concept-image">
                      {image ? (
                        <div
                          key={`${item.folder}-${currentIndex}`}
                          className={`concept-slide concept-slide-${direction}`}
                        >
                          <img
                            src={image}
                            alt={item.title}
                            loading={index === 0 ? "eager" : "lazy"}
                          />
                        </div>
                      ) : (
                        <div className="concept-image-placeholder">
                          <i className="bi bi-image"></i>
                          <span>Loading images...</span>
                        </div>
                      )}

                      {/* ARROWS */}
                      {images.length > 1 && (
                        <>
                          <button
                            type="button"
                            className="concept-arrow concept-arrow-left"
                            onClick={() =>
                              handlePrevious(item.folder, images.length)
                            }
                            aria-label="Previous image"
                          >
                            <i className="bi bi-chevron-left"></i>
                          </button>

                          <button
                            type="button"
                            className="concept-arrow concept-arrow-right"
                            onClick={() =>
                              handleNext(item.folder, images.length)
                            }
                            aria-label="Next image"
                          >
                            <i className="bi bi-chevron-right"></i>
                          </button>

                          {/* IMAGE COUNTER */}
                          <div className="concept-image-counter">
                            {currentIndex + 1} / {images.length}
                          </div>
                        </>
                      )}
                    </div>

                    <div className="concept-number">
                      {String(index + 1).padStart(2, "0")}
                    </div>
                  </div>

                  {/* CONTENT */}
                  <div className="concept-content">
                    <span className="section-label">{item.label}</span>

                    <h2>{item.title}</h2>

                    <div className="concept-description">{item.text}</div>

                    {item.directLink ? (
                      <Link to={item.directLink} className="concept-button">
                        Explore Offers
                        <i className="bi bi-arrow-right"></i>
                      </Link>
                    ) : (
                      <button
                        type="button"
                        className="concept-button"
                        onClick={() => setSelectedSection(item)}
                      >
                        Explore Concepts
                        <i className="bi bi-arrow-right"></i>
                      </button>
                    )}
                  </div>
                </article>
              );
            })}
          </div>
        </section>

        {/* WHY LIFETIME CREATION */}
        {/* <section className="about-why">
          <div className="about-container">
            <div className="about-why-grid">
              <div>
                <span className="section-label">LIFETIME CREATION</span>

                <h2>Bringing Embroidery Ideas to Life</h2>
              </div>

              <div className="about-why-content">
                <p>
                  Embroidery is more than decoration. It is a combination of
                  creativity, craftsmanship and technology. At LifeTime
                  Creation, we bring these elements together to provide
                  embroidery designs that can inspire new fashion creations.
                </p>

                <p>
                  Whether you are looking for a{" "}
                  <strong>machine embroidery design</strong> for a commercial
                  project, a beautiful{" "}
                  <strong>Sut or saree embroidery pattern</strong>, a{" "}
                  <strong>kurti or blouse design</strong>, or a creative{" "}
                  <strong>neckline and gala embroidery concept</strong>, our
                  growing collection provides different ideas for your next
                  project.
                </p>
              </div>
            </div>
          </div>
        </section> */}

        {/* CTA */}
        <section className="about-cta">
          <div className="about-container">
            <span className="section-label">DISCOVER MORE</span>

            <h2>Find Your Next Embroidery Design</h2>

            <p>
              Explore our embroidery designs and concepts and discover patterns
              for your next creative project.
            </p>

            <div className="about-buttons">
              <Link
                to="/category?cid=12&subcid=35&icid=200&menu=MULTI%20DESIGN"
                className="about-btn about-btn-primary"
              >
                Explore Designs
                <i className="bi bi-arrow-right"></i>
              </Link>
            </div>
          </div>
        </section>
      </div>
      {selectedSection && (
        <div
          className="concept-modal-overlay"
          onClick={() => setSelectedSection(null)}
        >
          <div className="concept-modal" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              className="concept-modal-close"
              onClick={() => setSelectedSection(null)}
              aria-label="Close"
            >
              <i className="bi bi-x-lg"></i>
            </button>

            <div className="concept-modal-icon">
              <i className="bi bi-grid-3x3-gap-fill"></i>
            </div>

            <span className="section-label">SELECT DESIGN TYPE</span>

            <h3>{selectedSection.title}</h3>

            <p>Choose the embroidery design type you want to explore.</p>

            <div className="concept-link-list">
              {selectedSection.links.map((link, index) => (
                <Link
                  key={index}
                  to={link.url}
                  target="_blank"
                  className="concept-link-item"
                  onClick={() => setSelectedSection(null)}
                >
                  <span>
                    <i className="bi bi-arrow-right-circle-fill"></i>
                    {link.name}
                  </span>

                  <i className="bi bi-chevron-right"></i>
                </Link>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
